import { render, staticRenderFns } from "./AccountCreation.vue?vue&type=template&id=83e51ed0&"
import script from "./AccountCreation.vue?vue&type=script&lang=js&"
export * from "./AccountCreation.vue?vue&type=script&lang=js&"
import style0 from "./AccountCreation.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports